var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesComposeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 24C13.334 25.4728 14.5279 26.6667 16.0007 26.6667C17.4734 26.6667 18.6673 25.4728 18.6673 24V18.6667H24.0006C25.4734 18.6667 26.6673 17.4728 26.6673 16C26.6673 14.5272 25.4734 13.3333 24.0006 13.3333H18.6673V7.99999C18.6673 6.52724 17.4734 5.33333 16.0007 5.33333C14.5279 5.33333 13.334 6.52724 13.334 7.99999V13.3333L8.00065 13.3333C6.52789 13.3333 5.33398 14.5272 5.33398 16C5.33398 17.4728 6.52789 18.6667 8.00065 18.6667L13.334 18.6667V24Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesComposeicon);
export default __webpack_public_path__ + "static/media/messages-composeicon.e0bae23380a97c95a469301b6386551d.svg";
export { ForwardRef as ReactComponent };